import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "8",
      cy: "8",
      r: "7",
      fill: "#000"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M4.26 8.663V7.338h7.48v1.325z"
    }, null, -1)
  ])))
}
export default { render: render }